import React, { useEffect, useState, useRef } from 'react';
import { getCookie, getDeviceList, mergeDevices, refreshToken, setCookie, storeTokens } from 'shared/utils/IotUtils';
import style from "./AdminIot.module.css";
import axios from 'axios';
import IoTDevice from './IoTDevice';
import { toast } from 'react-toastify';
import { requester } from 'App';


function AdminIot() {
    const [username, setUsername] = useState("heojun.japan@gmail.com");
    const [password, setPassword] = useState("qhfkal0813!");
    const [region, setRegion] = useState('44'); // Default: EU
    const [platform, setPlatform] = useState('tuya'); // Default: Smart Life
    const [devices, setDevices] = useState([]);
    const [baseUrl, setBaseUrl] = useState("https://px1.tuyaeu.com/homeassistant/");
    const [isLoggedIn, setLogin] = useState();
    const timerRef = useRef(null); // 타이머 ID를 저장

    // 매핑 관련 새로운 상태 변수들
    const [stores, setStores] = useState([]);
    const [deviceMappings, setDeviceMappings] = useState({});
    const [filterType, setFilterType] = useState('all'); // 'all', 'mapped', 'unmapped'

    // 새로운 상태 변수 추가
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [selectedStoreForBatch, setSelectedStoreForBatch] = useState('');
    const [showBatchMapping, setShowBatchMapping] = useState(false);

    // 추가 상태 변수
    const [selectedStore, setSelectedStore] = useState(null);
    const [mappedIotDevices, setMappedIotDevices] = useState([]);
    const [loading, setLoading] = useState(false);

    // 새로운 상태 변수 추가
    const [step, setStep] = useState('store-selection'); // 'store-selection' 또는 'device-mapping'

    // 검색 관련 상태 변수 추가
    const [deviceSearchTerm, setDeviceSearchTerm] = useState('');
    const [storeSearchTerm, setStoreSearchTerm] = useState('');

    const refresh = () => {
        getDeviceList(baseUrl, devices, true, (result) => {
            setDevices(result);
        });

        // 새로운 타이머 설정
        timerRef.current = setTimeout(() => {
            refresh();
        }, 60000);
    };

    useEffect(() => {
        const tuyaAccessToken = getCookie("access_token");
        const tuyaRefreshToken = getCookie("sl_refresh_token");
        const tuyaExpiresIn = getCookie("sl_expires_in");

        if (tuyaAccessToken !== "") {
            const region = tuyaAccessToken.substring(0, 2);

            if (region === "EU") {
            } else if (region === "AY") {
                setBaseUrl("https://px1.tuyacn.com/homeassistant/");
            } else if (region === "AZ") {
                setBaseUrl("https://px1.tuyaus.com/homeassistant/");
            }

            // 토큰이 있는 경우에도 로그인 상태를 true로 설정
            setLogin(true);

            // 매장 정보 로드
            fetchStores();

            // 디바이스 목록과 매핑 정보 함께 로드
            loadDevicesAndMappings();
        } else {
            handleLogin();
        }

        // 주기적 갱신 설정
        timerRef.current = setTimeout(() => {
            loadDevicesAndMappings();
        }, 60000);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, []);

    const onDeviceChanged = (changedDevice) => {

        setDevices(devices.map(device => {
            if (device.id === changedDevice.id) {
                return {
                    ...device,
                    data: changedDevice.data
                };
            } else {
                return device;
            }
        }))
    }

    const handleLogin = async (e) => {
        // e.preventDefault();

        let url = `${baseUrl}auth.do`;
        if (region === '1') {
            url = `${baseUrl.replace('eu', 'us')}auth.do`;
        }

        const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
        };

        const data = new URLSearchParams({
            userName: username,
            password: password,
            countryCode: region,
            bizType: platform,
            from: "tuya",
        });

        try {
            const response = await axios.post(url, data, { headers });

            const responseData = response.data;

            if (responseData.access_token) {
                callbackLogin("SUCCESS", responseData);
            } else {
                callbackLogin("FAILURE", responseData);
            }
        } catch (error) {
            console.error("Login error:", error);
            callbackLogin("ERROR");
        }
    }

    const callbackLogin = (status, result) => {

        if (status === "SUCCESS") {
            setLogin(true);
            storeTokens(result);

            // 매장 정보 로드
            fetchStores();

            // 디바이스 목록과 매핑 정보 함께 로드
            loadDevicesAndMappings();
        } else if (status === "FAILURE") {
            console.log(status);
        } else {
            console.log(status);
        }
    }


    const onGetDevicesClick = async () => {
        loadDevicesAndMappings();
    }

    // 매장 데이터 로드
    useEffect(() => {

        if (isLoggedIn) {
            fetchStores();
        }
    }, [isLoggedIn]);

    const fetchStores = async () => {
        setLoading(true);
        try {

            requester.findAllStores((result) => {

                setLoading(false);
                if (result && result.data) {
                    setStores(result.data);

                    // 기기-매장 매핑 정보 로드
                    fetchDeviceMappings();
                } else {
                    toast.error('매장 정보 로드 오류');
                }
            });
        } catch (error) {
            setLoading(false);
            console.error('매장 정보 로드 오류:', error);
            toast.error('매장 정보 로드 오류');
        }
    };

    // 매핑 정보 로드
    const fetchDeviceMappings = async () => {
        try {
            requester.findAllIotDevices((result) => {
                if (result && result.data) {
                    console.log("result", result);
                    const mappings = {};
                    result.data.forEach(device => {
                        if (device.storeId) {
                            mappings[device.iotId] = device.storeId;
                        }
                    });
                    setDeviceMappings(mappings);

                    // 이미 로드된 디바이스 데이터가 있다면 매핑 정보와 병합
                    if (devices && devices.length > 0) {
                        const mergedDevices = mergeDeviceData(devices, result.data);
                        setDevices(mergedDevices);
                    }
                }
            });
        } catch (error) {
            console.error('매핑 정보 로드 오류:', error);
        }
    };

    // 매장 선택 함수
    const handleStoreSelect = (store) => {
        setSelectedStore(store);
        setLoading(true);
        requester.findAllByStoreId({ storeId: store.id }, (result) => {
            setLoading(false);
            if (result && result.data) {
                setMappedIotDevices(result.data);
                // 매장 선택 후 디바이스 매핑 단계로 이동
                setStep('device-mapping');
                // 브라우저 히스토리에 상태 추가
                window.history.pushState({ step: 'device-mapping' }, '');
            } else {
                setMappedIotDevices([]);
                // 매장 선택 후 디바이스 매핑 단계로 이동
                setStep('device-mapping');
                // 브라우저 히스토리에 상태 추가
                window.history.pushState({ step: 'device-mapping' }, '');
            }
        });
    };

    // 매장 선택 단계로 돌아가는 함수
    const goBackToStoreSelection = () => {
        setStep('store-selection');
        // 브라우저 히스토리 조작 (뒤로가기)
        window.history.back();
    };

    // 매핑 함수
    const assignDeviceToStore = (deviceId, storeId) => {
        if (!storeId) return;

        const device = devices.find(d => d.id === deviceId);
        if (!device) return;

        const deviceToMap = {
            iotId: device.id,
            iotName: device.name,
            iotType: device.dev_type,
            storeId: storeId,
            isActive: true
        };

        setLoading(true);
        requester.saveIotDevice([deviceToMap], (result) => {
            setLoading(false);
            if (result && result.data) {
                // 매핑 정보 업데이트
                setDeviceMappings({
                    ...deviceMappings,
                    [deviceId]: storeId
                });

                // 디바이스 데이터 업데이트
                setDevices(devices.map(d => {
                    if (d.id === deviceId) {
                        return {
                            ...d,
                            mapping: deviceToMap,
                            storeId: storeId
                        };
                    }
                    return d;
                }));

                // 매핑된 디바이스 목록 업데이트
                if (selectedStore && selectedStore.id === storeId) {
                    handleStoreSelect(selectedStore);
                }

                toast.success('기기가 매장에 성공적으로 할당되었습니다.');
            } else {
                toast.error('기기 할당에 실패했습니다.');
            }
        });
    };

    // 매핑 해제 함수
    const unassignDevice = (deviceId) => {
        const deviceToUnmap = {
            iotId: deviceId,
            storeId: null
        };

        setLoading(true);
        requester.saveIotDevice([deviceToUnmap], (result) => {
            setLoading(false);
            if (result && result.data) {
                // 매핑 정보 업데이트
                const newMappings = { ...deviceMappings };
                delete newMappings[deviceId];
                setDeviceMappings(newMappings);

                // 디바이스 데이터 업데이트
                setDevices(devices.map(d => {
                    if (d.id === deviceId) {
                        return {
                            ...d,
                            mapping: null,
                            storeId: null
                        };
                    }
                    return d;
                }));

                // 매핑된 디바이스 목록 업데이트
                if (selectedStore) {
                    handleStoreSelect(selectedStore);
                }

                toast.success('기기 할당이 해제되었습니다.');
            } else {
                toast.error('기기 할당 해제에 실패했습니다.');
            }
        });
    };

    // 디바이스 검색어 변경 핸들러
    const handleDeviceSearchChange = (e) => {
        setDeviceSearchTerm(e.target.value);
    };

    // 매장 검색어 변경 핸들러
    const handleStoreSearchChange = (e) => {
        setStoreSearchTerm(e.target.value);
    };

    // 필터링된 매장 목록
    const getFilteredStores = () => {
        if (!stores || !Array.isArray(stores)) return [];

        if (storeSearchTerm.trim() === '') {
            return stores;
        }

        const searchTermLower = storeSearchTerm.toLowerCase();
        return stores.filter(store =>
            store.storeName.toLowerCase().includes(searchTermLower) ||
            (store.address && store.address.toLowerCase().includes(searchTermLower))
        );
    };

    // 필터링된 기기 목록 - 검색 기능 추가
    const getFilteredDevices = () => {
        if (!devices || !Array.isArray(devices)) return [];

        // 먼저 선택된 매장에 관련된 기기만 필터링
        let filteredByStore = devices;

        // 그 다음 탭에 따라 필터링
        let filteredByTab;
        switch (filterType) {
            case 'mapped':
                filteredByTab = filteredByStore.filter(device => device.storeId === selectedStore?.id);
                break;
            case 'unmapped':
                filteredByTab = filteredByStore.filter(device => !device.storeId);
                break;
            default:
                filteredByTab = filteredByStore;
        }

        // 마지막으로 검색어로 필터링
        if (!deviceSearchTerm || deviceSearchTerm.trim() === '') {
            return filteredByTab;
        }

        const searchTermLower = deviceSearchTerm.toLowerCase();
        return filteredByTab.filter(device =>
            (device.name && device.name.toLowerCase().includes(searchTermLower)) ||
            (device.id && device.id.toLowerCase().includes(searchTermLower)) ||
            (device.dev_type && device.dev_type.toLowerCase().includes(searchTermLower))
        );
    };

    // 매장별 기기 목록
    const getStoreDevices = (storeId) => {
        return devices.filter(device => device.storeId === storeId);
    };

    // 드래그 앤 드롭 이벤트 핸들러 추가
    useEffect(() => {
        // 드롭 영역에 드래그 이벤트 리스너 추가
        const dropZones = document.querySelectorAll(`.${style.dropZone}`);

        const handleDragOver = (e) => {
            e.preventDefault();
            e.currentTarget.classList.add(style.dragOver);
        };

        const handleDragLeave = (e) => {
            e.currentTarget.classList.remove(style.dragOver);
        };

        const handleDrop = (e) => {
            e.preventDefault();
            e.currentTarget.classList.remove(style.dragOver);

            const deviceId = e.dataTransfer.getData('deviceId');
            const storeElement = e.currentTarget.closest(`.${style.storeItem}`);

            if (deviceId && storeElement) {
                const storeId = storeElement.dataset.storeId;
                assignDeviceToStore(deviceId, storeId);
            }
        };

        dropZones.forEach(zone => {
            zone.addEventListener('dragover', handleDragOver);
            zone.addEventListener('dragleave', handleDragLeave);
            zone.addEventListener('drop', handleDrop);
        });

        return () => {
            dropZones.forEach(zone => {
                zone.removeEventListener('dragover', handleDragOver);
                zone.removeEventListener('dragleave', handleDragLeave);
                zone.removeEventListener('drop', handleDrop);
            });
        };
    }, [stores, deviceMappings]);

    // 매핑 상태 요약 컴포넌트
    const MappingStatusSummary = () => {
        const mappedCount = Object.keys(deviceMappings).length;
        const unmappedCount = devices.length - mappedCount;

        return (
            <div className={style.statusSummary}>
                <div className={style.statusCard}>
                    <div className={style.statusValue}>{devices.length}</div>
                    <div className={style.statusLabel}>전체 기기</div>
                </div>

                <div className={`${style.statusCard} ${style.mapped}`}>
                    <div className={style.statusValue}>{mappedCount}</div>
                    <div className={style.statusLabel}>등록된 기기</div>
                </div>

                <div className={`${style.statusCard} ${style.unmapped}`}>
                    <div className={style.statusValue}>{unmappedCount}</div>
                    <div className={style.statusLabel}>미등록 기기</div>
                </div>
            </div>
        );
    };

    // 일괄 매핑 함수
    const batchAssignDevices = async () => {
        if (!selectedStore || selectedDevices.length === 0) return;

        setLoading(true);
        try {
            // 모든 디바이스 데이터를 배열로 구성
            const devicesToMap = selectedDevices.map(deviceId => {
                const device = devices.find(d => d.id === deviceId);
                return {
                    iotId: device.id,
                    iotName: device.name,
                    iotType: device.dev_type,
                    storeId: selectedStore.id,
                    isActive: true
                };
            });

            // 배열 형태로 한 번에 전송
            requester.saveIotDevice(devicesToMap, (result) => {
                setLoading(false);
                if (result && result.data) {
                    // 매핑 정보 업데이트
                    const newMappings = { ...deviceMappings };
                    selectedDevices.forEach(deviceId => {
                        newMappings[deviceId] = selectedStore.id;
                    });

                    setDeviceMappings(newMappings);
                    setSelectedDevices([]);

                    // 매핑된 디바이스 목록 업데이트
                    handleStoreSelect(selectedStore);

                    toast.success(`${selectedDevices.length}개 기기가 매장에 할당되었습니다.`);
                } else {
                    toast.error('기기 일괄 할당에 실패했습니다.');
                }
            });
        } catch (error) {
            setLoading(false);
            console.error('일괄 할당 오류:', error);
            toast.error('기기 일괄 할당 중 오류가 발생했습니다.');
        }
    };

    // 기기 선택 토글 함수
    const toggleDeviceSelection = (deviceId) => {
        setSelectedDevices(prev =>
            prev.includes(deviceId)
                ? prev.filter(id => id !== deviceId)
                : [...prev, deviceId]
        );
    };

    // 브라우저 뒤로가기 이벤트 처리
    useEffect(() => {
        const handlePopState = () => {
            // 현재 단계가 device-mapping이면 store-selection으로 변경
            if (step === 'device-mapping') {
                setStep('store-selection');
            }
        };

        // popstate 이벤트 리스너 등록
        window.addEventListener('popstate', handlePopState);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [step]);

    // 디바이스 데이터와 매핑 정보를 병합하는 함수
    const mergeDeviceData = (iotDevices, mappingData) => {
        if (!iotDevices || !Array.isArray(iotDevices) || !mappingData) return iotDevices;

        // 매핑 정보를 디바이스 ID를 키로 하는 객체로 변환
        const mappingMap = {};
        mappingData.forEach(mapping => {
            if (mapping.iotId) {
                mappingMap[mapping.iotId] = mapping;
            }
        });

        // IoT 디바이스 데이터에 매핑 정보 추가
        return iotDevices.map(device => {
            const mapping = mappingMap[device.id];
            return {
                ...device,
                mapping: mapping || null,
                storeId: mapping ? mapping.storeId : null
            };
        });
    };

    // 디바이스 목록과 매핑 정보를 함께 로드하는 함수
    const loadDevicesAndMappings = () => {
        setLoading(true);

        // IoT 서버에서 디바이스 목록 가져오기
        getDeviceList(baseUrl, devices, true, (iotDevices) => {
            // 우리 서버에서 매핑 정보 가져오기
            requester.findAllIotDevices((result) => {
                setLoading(false);

                if (result && result.data) {
                    // 매핑 정보 저장
                    const mappings = {};
                    result.data.forEach(device => {
                        if (device.storeId) {
                            mappings[device.iotId] = device.storeId;
                        }
                    });
                    setDeviceMappings(mappings);

                    // 디바이스 데이터와 매핑 정보 병합
                    const mergedDevices = mergeDeviceData(iotDevices, result.data);
                    setDevices(mergedDevices);
                } else {
                    setDevices(iotDevices);
                    toast.error('매핑 정보 로드 오류');
                }
            });
        });
    };

    return (
        <div className={style.container}>
            <div className={style.loginForm}>
                <label htmlFor="username">Smart Life / Tuya Username: </label>
                <div className="in-line-div">
                    <input
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <br />
                <label htmlFor="password">Smart Life / Tuya Password: </label>
                <div className="in-line-div">
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <br />
                <label htmlFor="region">Region: </label>
                <div className="in-line-div">
                    <select
                        id="region"
                        value={region}
                        onChange={(e) => setRegion(e.target.value)}
                    >
                        <option value="44">&nbsp; EU</option>
                        <option value="1">&nbsp; US</option>
                    </select>
                </div>
                <label htmlFor="platform">Platform: </label>
                <div className="in-line-div">
                    <select
                        id="platform"
                        value={platform}
                        onChange={(e) => setPlatform(e.target.value)}
                    >
                        <option value="smart_life">&nbsp; Smart Life</option>
                        <option value="tuya">&nbsp; Tuya</option>
                    </select>
                </div>

                <br />
                <div className="in-line-div">
                    <input type="submit" value="Submit" onClick={handleLogin} />
                </div>
                <br />
                <button onClick={onGetDevicesClick}>getDevices</button>
            </div>

            {step === 'store-selection' ? (
                // 매장 선택 단계
                <div className={style.storeSelectionStep}>
                    <h2 className={style.stepTitle}>1단계: 매장 선택</h2>
                    <p className={style.stepDescription}>
                        IoT 디바이스를 관리할 매장을 선택해주세요.
                    </p>

                    {/* 매장 검색 추가 */}
                    <div className={style.searchContainer}>
                        <input
                            type="text"
                            className={style.searchInput}
                            placeholder="매장 이름 또는 주소로 검색..."
                            value={storeSearchTerm}
                            onChange={handleStoreSearchChange}
                        />
                        {storeSearchTerm && (
                            <button
                                className={style.clearSearchBtn}
                                onClick={() => setStoreSearchTerm('')}
                            >
                                ×
                            </button>
                        )}
                    </div>

                    {/* 검색 결과 정보 표시 */}
                    {storeSearchTerm.trim() !== '' && (
                        <div className={style.searchResultInfo}>
                            <p>
                                "{storeSearchTerm}" 검색 결과: {getFilteredStores().length}개 매장 찾음
                                {getFilteredStores().length === 0 && (
                                    <span className={style.noResults}> (검색 결과가 없습니다)</span>
                                )}
                            </p>
                        </div>
                    )}

                    <div className={style.storeSelectionPanel}>
                        <div className={style.storeList}>
                            {getFilteredStores().length > 0 ? (
                                getFilteredStores().map(store => (
                                    <div
                                        key={store.id}
                                        className={style.storeItem}
                                        onClick={() => handleStoreSelect(store)}
                                    >
                                        <h4>{store.storeName}</h4>
                                        <p>{store.address}</p>
                                        <div className={style.storeStats}>
                                            <span className={style.deviceCount}>
                                                {getStoreDevices(store.id).length}개 기기 매핑됨
                                            </span>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className={style.noStoresMessage}>
                                    {storeSearchTerm.trim() !== ''
                                        ? '검색 결과가 없습니다. 다른 검색어를 시도해보세요.'
                                        : '표시할 매장이 없습니다.'}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                // 디바이스 매핑 단계
                <div className={style.deviceMappingStep}>
                    <div className={style.stepHeader}>
                        <button
                            className={style.backButton}
                            onClick={goBackToStoreSelection}
                        >
                            ← 매장 선택으로 돌아가기
                        </button>

                        <h2 className={style.stepTitle}>
                            2단계: {selectedStore?.name} 매장의 IoT 디바이스 관리
                        </h2>
                    </div>

                    {/* 매핑 상태 요약 */}
                    <MappingStatusSummary />

                    {/* 검색 및 필터 컨트롤 */}
                    <div className={style.controlPanel}>
                        <div className={style.searchContainer}>
                            <input
                                type="text"
                                className={style.searchInput}
                                placeholder="디바이스 이름 또는 ID로 검색..."
                                value={deviceSearchTerm}
                                onChange={handleDeviceSearchChange}
                            />
                            {deviceSearchTerm && (
                                <button
                                    className={style.clearSearchBtn}
                                    onClick={() => setDeviceSearchTerm('')}
                                >
                                    ×
                                </button>
                            )}
                        </div>

                        <div className={style.filterControls}>
                            <button
                                className={`${style.filterBtn} ${filterType === 'all' ? style.active : ''}`}
                                onClick={() => setFilterType('all')}
                            >
                                전체 기기
                            </button>
                            <button
                                className={`${style.filterBtn} ${filterType === 'mapped' ? style.active : ''}`}
                                onClick={() => setFilterType('mapped')}
                            >
                                등록된 기기
                            </button>
                            <button
                                className={`${style.filterBtn} ${filterType === 'unmapped' ? style.active : ''}`}
                                onClick={() => setFilterType('unmapped')}
                            >
                                미등록 기기
                            </button>
                        </div>

                        <div className={style.viewControls}>
                            <button
                                className={style.batchBtn}
                                onClick={() => setShowBatchMapping(!showBatchMapping)}
                            >
                                {showBatchMapping ? '일괄 매핑 닫기' : '일괄 매핑'}
                            </button>
                        </div>
                    </div>

                    {/* 검색 결과 정보 표시 */}
                    {deviceSearchTerm.trim() !== '' && (
                        <div className={style.searchResultInfo}>
                            <p>
                                "{deviceSearchTerm}" 검색 결과: {getFilteredDevices().length}개 기기 찾음
                                {getFilteredDevices().length === 0 && (
                                    <span className={style.noResults}> (검색 결과가 없습니다)</span>
                                )}
                            </p>
                        </div>
                    )}

                    {/* 일괄 매핑 패널 */}
                    {showBatchMapping && (
                        <div className={style.batchMappingPanel}>
                            <h3>일괄 매핑 - {selectedStore?.name}</h3>
                            <div className={style.batchControls}>
                                <button
                                    className={style.batchAssignBtn}
                                    disabled={selectedDevices.length === 0}
                                    onClick={() => batchAssignDevices()}
                                >
                                    {selectedDevices.length}개 기기 할당
                                </button>
                            </div>

                            <div className={style.selectedDevicesCount}>
                                선택된 기기: {selectedDevices.length}개
                            </div>
                        </div>
                    )}

                    {/* 디바이스 목록 */}
                    <div className={style.deviceList}>
                        {getFilteredDevices().length > 0 ? (
                            getFilteredDevices().map((device, index) => (
                                <div
                                    className={`${style.deviceFrame} ${deviceMappings[device.id] === selectedStore?.id ? style.mapped : style.unmapped}`}
                                    key={index}
                                >
                                    {showBatchMapping && (
                                        <div className={style.deviceCheckbox}>
                                            <input
                                                type="checkbox"
                                                checked={selectedDevices.includes(device.id)}
                                                onChange={() => toggleDeviceSelection(device.id)}
                                            />
                                        </div>
                                    )}

                                    <IoTDevice data={device} onDeviceChanged={onDeviceChanged} />

                                    {/* 매핑 상태 표시 및 컨트롤 */}
                                    <div className={style.mappingControls}>
                                        {deviceMappings[device.id] === selectedStore?.id ? (
                                            <div className={style.mappingInfo}>
                                                <span className={style.mappedLabel}>
                                                    매장에 등록됨
                                                </span>
                                                <button
                                                    className={style.unmapBtn}
                                                    onClick={() => unassignDevice(device.id)}
                                                >
                                                    해제
                                                </button>
                                            </div>
                                        ) : (
                                            <button
                                                className={style.mapBtn}
                                                onClick={() => assignDeviceToStore(device.id, selectedStore.id)}
                                            >
                                                {selectedStore.storeName}에 등록
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className={style.noDevicesMessage}>
                                {deviceSearchTerm.trim() !== ''
                                    ? '검색 결과가 없습니다. 다른 검색어를 시도해보세요.'
                                    : '표시할 기기가 없습니다.'}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* 로딩 인디케이터 */}
            {loading && (
                <div className={style.loadingOverlay}>
                    <div className={style.spinner}></div>
                </div>
            )}
        </div>
    );
}

export default AdminIot;
